const invokeAcadInteropFunction = (invokeInfo) => {
  // Parameter normalization
  if (typeof invokeInfo === 'undefined') {
    return null;
  } else if (typeof invokeInfo === 'object') {
    invokeInfo = JSON.stringify(invokeInfo);
  }
  if (typeof window.execAsync === 'undefined') {
    return Promise.reject('Function "execAsync" not available.');
  }
  return new Promise((resolve, reject) => {
    window.execAsync(
      invokeInfo,
      function (data) {
        const result = JSON.parse(data);
        if (typeof resolve == 'function') {
          resolve(result.retValue);
        }
      },
      function (data) {
        const result = JSON.parse(data);
        if (typeof reject == 'function') {
          if (result.retErrorString === undefined) reject(result.retCode);
          else reject(result.retCode, result.retErrorString);
        }
      }
    );
  });
};

export const acadInterop = {
  invokeAcadInteropFunction,
  getContextInfo: (count) => {
    return acadInterop.invokeAcadInteropFunction({
      functionName: 'help_Api.getContextInfo',
      invokeAsCommand: false,
      functionParams: {count},
    });
  },
  getAccessToken: () => {
    return acadInterop.invokeAcadInteropFunction({
      functionName: 'Ac_ApplicationInterop.getSignInToken',
      functionParams: {},
    });
  },
};
